// Desk & parking summary for a review step — RON-5466.
//
// Extracted from VisitorReviewStep in Phase 4 so the contractor wizard shows the same summary. Both
// wizards offer desk and parking on their visit-details step, so a review that omitted it would let
// a host book a desk and never see it confirmed.

import { useTranslation } from "react-i18next";

import { formatDateToEEEddMMM } from "../../../utils/CommonUtils.js";
import { daysOf } from "../visitorDateUtils.js";
import VisitorDetailRow from "./VisitorDetailRow.jsx";
import { resourceDays } from "./VisitorResourcePicker.jsx";

const VisitorResourceSummary = ({ form, canAssignDesk, canAssignParking }) => {
  const { t } = useTranslation("common");

  // Nothing to summarise if the employee cannot assign either.
  if (!canAssignDesk && !canAssignParking) return null;

  const totalDays = daysOf(form.startDate, form.endDate).length;

  // "Not booked" / "All N days" / a list of the specific days — mirrors the prototype's resLabel.
  const resourceLabel = (kind) => {
    const selected = resourceDays(form.resources, form.startDate, form.endDate, kind);

    if (selected.length === 0) return t("react_visitors_not_booked");
    if (selected.length === totalDays) {
      return totalDays > 1
        ? t("react_visitors_all_days").replace("%s", String(totalDays))
        : t("yes");
    }

    return selected.map((day) => formatDateToEEEddMMM(day)).join(", ");
  };

  return (
    <div className="visitor-card">
      <p className="visitor-card__title">{t("react_visitors_resources_summary")}</p>
      {canAssignDesk && (
        <VisitorDetailRow
          label={t("react_visitors_desk")}
          value={resourceLabel("desk")}
        />
      )}
      {canAssignParking && (
        <VisitorDetailRow
          label={t("react_visitors_parking")}
          value={resourceLabel("parking")}
        />
      )}
      <p className="visitor-card__hint">{t("react_visitors_resources_on_submit")}</p>
    </div>
  );
};

export default VisitorResourceSummary;
